import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 12h-2l9 -9l8 8","key":"svg-0"}],["path",{"d":"M5 12v7a2 2 0 0 0 2 2h6","key":"svg-1"}],["path",{"d":"M9 21v-6a2 2 0 0 1 2 -2h2c.688 0 1.294 .347 1.654 .875","key":"svg-2"}],["path",{"d":"M17 19a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1v-2","key":"svg-3"}],["path",{"d":"M18 18v-1.5a1.5 1.5 0 1 1 3 0v1.5","key":"svg-4"}]]

const IconHomeLock = createReactComponent('outline', 'home-lock', 'HomeLock', __iconNode);

export default IconHomeLock;